import React,{useState} from 'react';
import {FaEye,FaEyeSlash} from 'react-icons/fa';
import '../styles/styles.css';


const PasswordInput = ({label,value,onChange}) => {
    const [show,setShow]=useState(false);

    return(
        <div className='form-group password-group' >
            <label>{label} <span className='required-text' >*Obligatorio</span> </label>
            <div>
                <input
                    type={show ? "text":"password"}
                    name='password'
                    className='form-control'
                    value={value}
                    onChange={onChange}
                    autoComplete='new-password'
                />
                <button 
                    type='button'
                    className='btn-eye'
                    onClick={()=>setShow(!show)}
                >
                    {show ? <FaEyeSlash /> : <FaEye />}
                </button>
            </div>
        </div>
    );
};

export default PasswordInput;